import React from "react";

import Helmet from "../../components/Helmet";
import OrderStatusPageContent from "../../shopcrate-framework/page-content/OrderStatusPageContent";

function OrderStatus() {
    return (
        <React.Fragment>
            <Helmet title="Bestelling"/>
            <div className="jumbotron jumbotron-fluid jumbotron-header jumbotron-sm">
                <div className="container">
                    <h1>Bestelling</h1>
                </div>
            </div>
            <div className="container">
                <OrderStatusPageContent/>
            </div>
        </React.Fragment>
    );
}

export default React.memo(OrderStatus);
